export function asString(input: any) {
  return typeof input === "string" ? input : undefined;
}

export function isTimeFormat(str: string) {
  const regex = /^\d{2}:\d{2}:\d{2}$/;
  return regex.test(str);
}
